export default {
  id: {
    asc: 'id_ASC',
    desc: 'id_DESC',
  },
  name: {
    asc: 'name_ASC',
    desc: 'name_DESC',
  },

  salesChannel: {
    asc: 'salesChannel_ASC',
    desc: 'salesChannel_DESC',
  },
  marketSegment: {
    asc: 'marketSegment_ASC',
    desc: 'marketSegment_DESC',
  },
  accountType: {
    asc: 'accountType_ASC',
    desc: 'accountType_DESC',
  },
  accountSubType: {
    asc: 'accountSubType_ASC',
    desc: 'accountSubType_DESC',
  },
  country: {
    asc: 'country_ASC',
    desc: 'country_DESC',
  },
  currency: {
    asc: 'currency_ASC',
    desc: 'currency_DESC',
  },
  status: {
    asc: 'status_ASC',
    desc: 'status_DESC',
  },
};
